module.exports = __webpack_public_path__ + "img/bold.20753dd1.svg";